import { useQuery, useQueryClient } from "@tanstack/react-query";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/accounts/shared";

const TONE = { pending: "bg-amber-100 text-amber-800", received: "bg-sky-100 text-sky-800", accepted: "bg-emerald-100 text-emerald-800", rejected: "bg-rose-100 text-rose-700" };

// Client side: document requests raised by the business's CA firm.
export default function ClientRequestsTab() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["ca-client-reqs"], queryFn: async () => (await api.get("/ca/client-requests")).data });
  const upload = async (r, file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    try { await api.post(`/ca/client-requests/${r.id}/upload`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Sent to your CA"); qc.invalidateQueries({ queryKey: ["ca-client-reqs"] }); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const open = async (r, f) => {
    try { const res = await api.get(`/ca/client-requests/${r.id}/files/${f.id}`, { responseType: "blob" }); window.open(URL.createObjectURL(res.data), "_blank"); } catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <Card className="space-y-2" testid="ca-requests-tab">
      <p className="font-semibold">Documents requested by your CA</p>
      {!data?.items?.length && <p className="text-sm text-slate-400" data-testid="ca-requests-empty">No requests.</p>}
      {(data?.items || []).map((r) => (
        <div key={r.id} className="border-t border-slate-100 pt-2 text-sm" data-testid={`ca-req-${r.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-2"><b>{r.title}</b><span className={`rounded-full px-2 py-0.5 text-xs ${TONE[r.status]}`} data-testid={`ca-req-status-${r.id}`}>{r.status}</span></div>
          <p className="text-xs text-slate-500">{r.firm_name} · {r.doc_type.replace("_", " ")}{r.vendor_name && ` · ${r.vendor_name}`}{r.ref_label && ` · ${r.ref_label}`} · due {r.deadline || "—"} · for {r.responsible_name}</p>
          {r.description && <p className="text-xs">{r.description}</p>}
          {r.history.filter((h) => h.comment).map((h, i) => <p key={i} className="text-xs text-rose-700">{h.action}: {h.comment}</p>)}
          <div className="mt-1 flex flex-wrap items-center gap-3 text-xs">
            {r.files.map((f) => <button key={f.id} className="text-sky-700 underline" onClick={() => open(r, f)}>{f.label}</button>)}
            {["pending", "rejected", "received"].includes(r.status) && r.firm_access_active && <label className="cursor-pointer rounded border border-dashed border-slate-300 px-2 py-0.5">Upload document
              <input type="file" className="hidden" accept=".pdf,.jpg,.jpeg,.png" onChange={(e) => upload(r, e.target.files?.[0])} data-testid={`ca-req-upload-${r.id}`} /></label>}
            {!r.firm_access_active && <span className="text-slate-400">The firm's access is no longer active.</span>}
          </div>
        </div>))}
    </Card>
  );
}
